<template>
  <div class="container" style="height: 100%">
    <div v-if="!selectedCategory" class="text-center">
      <h1 class="header">{{ survey.description }}</h1>
      <div class="row" style="margin-top: 5px">
        <div v-for="(category, index) in categories" :key="index">
          <div class="image col-12 col-sm-5 col-md-4">
            <div class="image__controls">
              <input @click.prevent="onCategoryClick(category)" ref="selected_image" v-model="selectedCategoryId" :value="category.id" type="radio"
                name="selected_image" style="cursor: pointer">
            </div>

            <div class="image__content" :class="{ 'animateMe': isCategoryClicked(category.id) }" @click.prevent="onCategoryClick(category)">
              <div class="image__image" :style="{ backgroundImage: 'url(' + category.image + ')' }"></div>
              <div class="text-center">
                <h3 class="image__title text-capitalize">{{ category.name }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!categoryConfirmed" class="collage">
      <h1 class="header">Would you like to confirm your category selection?</h1>
      <div class="image-grid">
        <div v-for="(imageUrl, index) in collageImages" :key="`collage-${index}`" class="collage-image-container">
          <img class="img-responsive" :src="imageUrl"/>
        </div>
      </div>
      <Buttons
        :show-products-btn="false"
        :is-first="false"
        :is-last="false"
        :is-visual-survey="false"
        :hide-end-survey="true"
        next-text="Yes"
        prev-text="No"
        :disable-required="true"
        @next="confirmCategory"
        @prev="selectedCategory = selectedCategoryId = null"
    ></Buttons>
    </div>
    <div v-else class="question-area">
      <h1>{{ selectedCategory.name }}</h1>
      <IfElseQuestion
        :question="question"
        :category="selectedCategory.name"
        :survey="survey"
        @answer="next"
        ></IfElseQuestion>
      <Buttons
          :question="question"
          :is-first="isFirst"
          :is-last="isLast"
          :disable-required="true"
          @next="next"
          @prev="prev"
          @endSurvey="$emit('endSurvey')"
      ></Buttons>
    </div>
  </div>
</template>

<script>
import Buttons from '@src/components/survey/Buttons.vue'
import IfElseQuestion from '@src/components/survey/IfElseQuestion.vue'

import { mapActions, mapGetters } from "vuex";

  export default {
    components: {
      Buttons,
      IfElseQuestion
    },
    props: {
      cur_pos: Number,
      survey: Object
    },
    data() {
      return {
        selectedCategoryId: {},
        selectedCategory: null,
        categoryClicked: false,
        categoryConfirmed: false,
        baseCategoryQuestions: [],
        categoryQuestionsByParentImageId: {},
        questionsById: {},
        baseQuestionIndex: 0,
        question: null,
        questionHistory: []
      }
    },
    computed: {
      ...mapGetters('take_survey', ['isBeforeSendingTime', 'categories', 'getCategoryById', 'questions']),
      cssVars() {
        return {
          '--min-height-desktop': ((((this.windowHeight - 200) / 2) - 10) > 200) ? (((this.windowHeight - 200) / 2) +
            15) + 'px' : (200) + 'px',
          '--min-height-mobile': ((((this.windowHeight - 200) / 2) - 10) > 200) ? (((this.windowHeight - 240) / 2) +
            15) + 'px' : (200) + 'px',
        }
      },
      isFirst() {
        return this.question === this.baseCategoryQuestions[0];
      },
      isLast() {
        return false;
      },
      collageImages() {
        const primary = []
        const secondary = []
        this.baseCategoryQuestions.forEach((q) => {
          q.images.forEach((i, index) => {
            if (index === 0) {
              primary.push(i.image.url)
            } else {
              secondary.push(i.image.url)
            }
          })
        })
        Object.values(this.categoryQuestionsByParentImageId).forEach((q) => {
          q.images.forEach((i, index) => {
            if (index === 0) {
              primary.push(i.image.url)
            } else {
              secondary.push(i.image.url)
            }
          })
        })
        const images = primary.concat(secondary)
        return images.slice(0, 10)
      }
    },
    watch: {
      categories() {
        const selectedCategory = this.categories.filter((c) => c.is_selected);
        if (selectedCategory.length > 0) {
          this.selectedCategoryId = selectedCategory[0].id
        }
      },
      selectedCategory() {
        for (var i = 0; i < this.questions.length; i++) {
          const q = this.questions[i];
          this.questionsById[q.id] = q;
          if (q.if_else_category_id === this.selectedCategoryId) {
            if (!q.parent_question_image) {
              this.baseCategoryQuestions.push(q);
            } else {
              this.categoryQuestionsByParentImageId[q.parent_question_image.id] = q;
            }
          }
          this.question = this.baseCategoryQuestions[0];
          this.questionHistory = [];
        }
      },
      selected_value: {
        handler: function (val, oldVal) {
          if (val !== oldVal) {

            this.SET_COMMAND_DO_SUBMIT(true)
          }
        },
        deep: true,
      },
    },
    methods: {
      ...mapActions('take_survey', ['sendAnswer', 'sendIfElseCategoryAnswer']),
      isCategoryClicked(categoryId) {
        return this.categoryClicked && categoryId === this.selectedCategoryId && (!this.selectedCategory || this.selectedCategory.id !== categoryId)
      },
      onCategoryClick(category) {
        this.categoryClicked = true
        this.selectedCategoryId = category.id
        setTimeout(() => {
          this.selectedCategory = this.getCategoryById(this.selectedCategoryId);
        }, 500)
      },
      confirmCategory() {
        this.sendIfElseCategoryAnswer({'surveyId': this.survey.id, 'ifElseCategoryId': this.selectedCategoryId}).then(() => {
          this.categoryConfirmed = true;
        })
      },
      next(imageId) {
        this.questionHistory.push(this.question)
        imageId = imageId || this.question.answer || this.question.last_answer;
        if (this.categoryQuestionsByParentImageId[imageId]) {
          this.question = this.categoryQuestionsByParentImageId[imageId];
        } else if (this.baseQuestionIndex < this.baseCategoryQuestions.length - 1) {
          this.baseQuestionIndex++;
          this.question = this.baseCategoryQuestions[this.baseQuestionIndex];
        } else {
          this.$emit('endSurvey');
        }

      },
      prev() {
        if (this.question.answer) {
          const answerData = {'answer': '', 'comment': null}
          this.sendAnswer({'surveyId': this.survey.id, 'questionId': this.question.id, 'answerData': answerData, 'removeAnswer': true}).then(() => {
            this.prevHelper()
          })
        } else {
          this.prevHelper()
        }
        
      },
      prevHelper() {
        if (this.questionHistory.length === 0) {
            this.selectedCategory = null;
            this.categoryConfirmed = false;
          } else {
            if (this.baseCategoryQuestions.indexOf(this.question)) {
                this.baseQuestionIndex--;
            }
            this.question = this.questionHistory.pop();
          }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .question-area {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-evenly;
    height: 100%;
  }

  .image-grid {
    display: grid;
    grid-template-columns: 20% 20% 20% 20% 20%;
    grid-template-rows: 50% 50%;
  }

  .collage-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }

  .animateMe {
    animation: border 1s;
  }

  @keyframes border {
  0% {
    border: 3px solid orange;
    opacity: 1;
  }
  25% {
    border: 3px solid #63a297;
    opacity: 0.5;
  }
  50% {
    opacity: 1;
    border: 3px solid #9ebca8;
  }
  75% {
    opacity: 0.5;
    border: 3px solid blue;
  }
  100% {
    opacity: 1;
    border: 3px solid silver;
  }
}


  .header {
    color: #444;
  }

  .image {
    display: flex;
    flex-direction: row;
    cursor: pointer;
    position: relative;
    height: 100%;
    min-height: 200px;
    margin-bottom: 10px;

    &__controls {
      position: absolute;
      right: 30px;
      top: 10px;

      a {
        color: inherit;
        padding-left: 10px;
      }

      input {
        transform: scale(1.5);
      }

      a:hover {
        color: #6bcafd;
      }
    }

    &:hover {
      -webkit-filter: brightness(103%);
      filter: brightness(103%);

    }

    &__image {
      padding: 5px;
      flex: 1;
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: center;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      height: 100%;
    }

    &__content {
      border: 3px solid #e7e7e7;
      padding-top: 5px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__title {
      border-top: 3px solid #e7e7e7;
    }

  }
  .collage {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>